import {faArrowRight} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Flex, Space, Tag} from 'antd';
import {ReactElement, useMemo} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {gray7} from '../../../../../../../../css/var-export.scss';
import {useReviewSentiments} from '../../../../../../../../service/reviews/reviews-tags';
import {ReviewSentimentEnum, ReviewSentimentType} from '../../../../../../../../service/reviews/reviews-type';
import {classNames} from '../../../../../../../../util/css';
import * as tagListStyles from '../../../../../tag-list/tag-list.scss';

import * as styles from './history-modal.scss';

type PropsType = {
    formattedDate: string | null;
    formattedTime: string | null;
    title: ReactElement;
    oldValue: string | null;
    newValue: string | null;
    oldText?: string | null;
    newText?: string | null;
};

function getSentimentClassName(sentiment: string | null | undefined): string | null {
    switch (sentiment) {
        case ReviewSentimentEnum.negative:
            return tagListStyles.TagList_aspectNegative;
        case ReviewSentimentEnum.neutral:
            return tagListStyles.TagList_aspectNeutral;
        case ReviewSentimentEnum.positive:
            return tagListStyles.TagList_aspectPositive;
        default:
            return null;
    }
}

function isReviewSentiment(value: string | null | undefined): value is ReviewSentimentType {
    return (
        value === ReviewSentimentEnum.positive ||
        value === ReviewSentimentEnum.neutral ||
        value === ReviewSentimentEnum.negative
    );
}

export function SentimentLog(props: PropsType): ReactElement {
    const {formattedDate, formattedTime, title, oldValue, newValue, oldText, newText} = props;
    const {data: sentimentsMap} = useReviewSentiments();

    const oldLabel = useMemo(() => {
        // eslint-disable-next-line no-undefined
        if (oldText !== undefined) {
            return oldText;
        }

        if (!oldValue) {
            return null;
        }

        return isReviewSentiment(oldValue) && sentimentsMap ? sentimentsMap[oldValue] : oldValue;
    }, [oldText, oldValue, sentimentsMap]);

    const newLabel = useMemo(() => {
        // eslint-disable-next-line no-undefined
        if (newText !== undefined) {
            return newText;
        }

        if (!newValue) {
            return null;
        }

        return isReviewSentiment(newValue) && sentimentsMap ? sentimentsMap[newValue] : newValue;
    }, [newText, newValue, sentimentsMap]);

    const oldClassName = getSentimentClassName(oldValue);
    const newClassName = getSentimentClassName(newValue);

    return (
        <div>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Flex align="center" gap={4} wrap>
                {title}
                <Space>
                    <Tag
                        className={classNames(
                            styles.HistoryModal_sentimentTag,
                            tagListStyles.TagList_itemAutotag,
                            oldClassName
                        )}
                    >
                        {oldLabel ?? '-'}
                    </Tag>
                    <FontAwesomeIcon color={gray7} fontSize={16} icon={faArrowRight} />
                    <Tag
                        className={classNames(
                            styles.HistoryModal_sentimentTag,
                            tagListStyles.TagList_itemAutotag,
                            newClassName
                        )}
                    >
                        {newLabel ?? '-'}
                    </Tag>
                </Space>
            </Flex>
        </div>
    );
}
